import React, { useState, useEffect } from 'react';
import { Trophy, X, ExternalLink } from 'lucide-react';

const VOTE_URL = 'https://app.emergent.sh/showcase/builder-apr26/4d05d7f7-3dd4-4589-9208-2a9e08212e82';
const STORAGE_KEY = 'contest_banner_dismissed_apr26';

export default function ContestBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* private mode */ }
  };

  if (!visible) return null;

  return (
    <div
      className="relative z-[70] bg-gradient-to-r from-[#FF5E1A] via-[#FF7A42] to-[#FF5E1A] text-black"
      data-testid="contest-banner"
    >
      <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-3 text-center">
        <Trophy className="w-4 h-4 flex-shrink-0" />
        <p className="text-xs sm:text-sm font-semibold leading-tight">
          <span className="hidden sm:inline">We're nominated for the Emergent Builder Contest — </span>
          <span className="sm:hidden">Emergent Builder Contest — </span>
          <a
            href={VOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contest-banner-vote-link"
            className="underline underline-offset-2 hover:no-underline font-bold inline-flex items-center gap-1"
          >
            Vote for AI Tuner Pro <ExternalLink className="w-3 h-3" />
          </a>
        </p>
        <button
          onClick={dismiss}
          data-testid="contest-banner-dismiss"
          aria-label="Dismiss"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-black/10 rounded-sm transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
